<script>
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  import { Nav, Login } from '../components/account';
  export let data;
  let portal = data.portal;
  let account = data.account;
  let session = data.session;
  let modal = false;
  let stripe = null;
  let stripeReady = false;
  let ready = false;
  let counter = 0;
  let images = [];
  let referrer = localStorage.getItem("referrer") || "";

  onMount(() => {
    preload();
    if (stripeReady) {
        stripe = Stripe('pk_live_Ge09dNvZo1XPnnlii26mH7Py00tAfnfTNt');
    }
    if (account && account.referrer) {
      if (account.referrer.startsWith("https://geosync.cloud"))
        referrer = "https://start.geosync.cloud";
      else
        referrer = account.referrer;
    }
    else if (!referrer) {
      if (document.referrer.startsWith("https://geosync.cloud"))
        referrer = "https://start.geosync.cloud";
      else
        referrer = document.referrer;
      localStorage.setItem("referrer", referrer);
    }
  });

    function preload() {
        let srcs = [
            "/img/subscription/free.jpg",
            "/img/subscription/360.jpg",
            "/img/subscription/pro.jpg",
            "/img/subscription/bronze.jpg"
        ]
        for (var i = 0; i < srcs.length; i++) {
            images[i] = new Image();
            images[i].src = srcs[i];
            images[i].onload = increment
            images[i].onerror = increment
        }
    }

    function increment() {
        counter++;
        if (counter === images.length) {
            ready = true;
        }
    }

  function stripeLoaded() {
    stripe = Stripe('pk_live_Ge09dNvZo1XPnnlii26mH7Py00tAfnfTNt');
  }

  function messageHandler(message) {
	if (message.detail.type == "modal") {
      modal = !modal;
    }
  }

  function selectHandler(plan) {
    if (account) {
        stripe.redirectToCheckout({
            sessionId: session[plan]
        }).then(function (result) {
            console.log(result)
        });
    }
    else {
        modal = true;
    }
  }
</script>

<svelte:head>
  <script src="https://js.stripe.com/v3/" on:load={stripeLoaded}></script>
</svelte:head>

<div class="container grid-xl" in:fade>
  <Login modal={modal} referrer={referrer} on:message={messageHandler} />
  <Nav page="Subscription" account={account} referrer={referrer} on:message={messageHandler} />
  {#if ready}
  <div id="plans" class="columns" in:fade>
      <div class="column col-sm-12 col-6">
          <div class="card">
              <div class="card-header">
                  <div class="tile tile-centered">
                  <div class="tile-content">
                      <div class="card-title h5">GeoSync FREE</div>
                  </div>
                  <div class="tile-action">
                      {#if !account}
                        <button class="btn btn-primary" on:click={function (e) {
                            e.currentTarget.blur();
                            selectHandler("free");
                        }}>Select</button>
                      {:else if account.type == "free"}
                        <span class="label label-secondary">Current</span>
                      {/if}
                  </div>
                  </div>
              </div>
              <div class="card-image">
              <img src="/img/subscription/free.jpg" class="img-responsive" alt="GeoSync FREE" />
              </div>
          </div>
      </div>
      <div class="column col-sm-12 col-6">
          <div class="card">
              <div class="card-header">
                  <div class="tile tile-centered">
                  <div class="tile-content">
                      <div class="card-title h5">GeoSync 360</div>
                  </div>
                  <div class="tile-action">
                      {#if !account}
                        <button class="btn btn-primary" on:click={function (e) {
                            e.currentTarget.blur();
                            selectHandler("360");
                        }}>Select</button>
                      {:else if portal}
                        {#if account && account.type == "360"}
                            <a class="btn btn-error" href={portal}>Cancel</a>
                        {:else}
                            <a class="btn btn-primary" href={portal}>Select</a>
                        {/if}
                      {:else if account.type == "360"}
                        <span class="label label-secondary">Current</span>
                      {:else if session["360"]}
                        <button class="btn btn-primary" on:click={function (e) {
                            e.currentTarget.blur();
                            selectHandler("360");
                        }}>Select</button>
                      {:else}
                        <a href="https://start.geosync.cloud/contact" class="btn btn-primary">Contact Us</a>
                      {/if}
                  </div>
                  </div>
              </div>
              <div class="card-image">
                  <img src="/img/subscription/360.jpg" class="img-responsive" alt="GeoSync 360" />
              </div>
          </div>
      </div>
  </div>
  <div class="columns">
      <div class="column col-sm-12 col-6">
          <div class="card">
              <div class="card-header">
                  <div class="tile tile-centered">
                  <div class="tile-content">
                      <div class="card-title h5">GeoSync Pro</div>
                  </div>
                  <div class="tile-action">
                      {#if !account}
                        <button class="btn btn-primary" on:click={function (e) {
                            e.currentTarget.blur();
                            selectHandler("pro");
                        }}>Select</button>
                      {:else if portal}
                        {#if account && account.type == "pro"}
                            <a class="btn btn-error" href={portal}>Cancel</a>
                        {:else}
                            <a class="btn btn-primary" href={portal}>Select</a>
                        {/if}
                      {:else if account.type == "pro"}
                        <span class="label label-secondary">Current</span>
                      {:else if session["pro"]}
                        <button class="btn btn-primary" on:click={function (e) {
                            e.currentTarget.blur();
                            selectHandler("pro");
                        }}>Select</button>
                      {:else}
                        <a href="https://start.geosync.cloud/contact" class="btn btn-primary">Contact Us</a>
                      {/if}
                  </div>
                  </div>
              </div>
              <div class="card-image">
              <img src="/img/subscription/pro.jpg" class="img-responsive" alt="GeoSync Pro" />
              </div>
          </div>
      </div>
      <div class="column col-sm-12 col-6">
          <div class="card">
              <div class="card-header">
                  <div class="tile tile-centered">
                  <div class="tile-content">
                      <div class="card-title h5">GeoSync Bronze</div>
                  </div>
                  <div class="tile-action">
                      {#if !account}
                        <button class="btn btn-primary" on:click={function (e) {
                            e.currentTarget.blur();
                            selectHandler("bronze");
                        }}>Select</button>
                      {:else if portal}
                        {#if account && account.type == "bronze"}
                            <a class="btn btn-error" href={portal}>Cancel</a>
                        {:else}
                            <a class="btn btn-primary" href={portal}>Select</a>
                        {/if}
                      {:else if account.type == "bronze"}
                        <span class="label label-secondary">Current</span>
                      {:else if session["bronze"]}
                        <button class="btn btn-primary" on:click={function (e) {
                            e.currentTarget.blur();
                            selectHandler("bronze");
                        }}>Select</button>
                      {:else}
                        <a href="https://start.geosync.cloud/contact" class="btn btn-primary">Contact Us</a>
                      {/if}
                  </div>
                  </div>
              </div>
              <div class="card-image">
                  <img src="/img/subscription/bronze.jpg" class="img-responsive" alt="GeoSync Bronze" />
              </div>
          </div>
      </div>
  </div>
  {:else}
    <div class="preloader-wrapper">
        <div class="preloader">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
  {/if}
</div>

<style>
  .card {
    border: 0;
  }
  .card .card-image {
      padding: 0.8rem;
  }
  .label {
      background-color: #eef0f3;
  }
</style>